// マスタ編集画面のタブと、CSVエクスポートの選択ポップアップで共通に使う「現在の件数」。
// 論理削除された行は存在しない扱いのため数えない。
// 専用の編集画面を持つマスタは、その画面が主として扱うテーブルの件数を代表として出す。

import type { ExtendedDB } from "../../../types/extendedDB";
import { allMasterConfigs } from "./configs";

function activeCountOf(rows: ReadonlyArray<{ deleted_at: number | null }>): number {
  return rows.filter((row) => row.deleted_at == null).length;
}

// マスタ編集画面のキーから、そのマスタの現在の件数を求める。
export function activeRowCountOf(db: ExtendedDB, masterKey: string): number {
  if (masterKey === "work-master") {
    return activeCountOf(db.works ?? []);
  }
  if (masterKey === "work-classification") {
    return activeCountOf(db.workTypes ?? []);
  }
  if (masterKey === "material-master") {
    return activeCountOf(db.materials ?? []);
  }
  if (masterKey === "mix-ratio-master") {
    return activeCountOf(db.mixRatioDefinitions ?? []);
  }
  const config = allMasterConfigs.find((entry) => entry.key === masterKey)?.config;
  if (config !== undefined) {
    return activeCountOf(config.collection(db));
  }
  return 0;
}
